export default __webpack_public_path__ + "static/media/schedule-sip-icon.ab9db87b.svg";